module.exports = __webpack_public_path__ + "media/images/flags/in-c1de42805adfdb8b335c95a6379f60a6.svg";